import { render, staticRenderFns } from "./TrailerDisplay.vue?vue&type=template&id=1846036a"
import script from "./TrailerDisplay.vue?vue&type=script&lang=js"
export * from "./TrailerDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports